import { __exports as build } from './_virtual-index3.js';
import { __require as requireInteropRequireDefault } from './node_modules-@babel-runtime-helpers-interopRequireDefault.js';
import { __require as requireTokenEngine } from './vp-js-token-engine-build-TokenEngine.js';
import { __require as requirePresentationProvider } from './vp-js-token-engine-build-tokenGenerators-PresentationProvider.js';
import { __require as requirePresentationTokenFactory } from './vp-js-token-engine-build-tokenGenerators-PresentationTokenFactory.js';
import { __require as requireCouponCalloutTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-CouponCalloutTokenGenerator.js';
import { __require as requirePercentageTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PercentageTokenGenerator.js';
import { __require as requirePlusOrMinusTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PlusOrMinusTokenGenerator.js';
import { __require as requirePriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-PriceTokenGenerator.js';
import { __require as requireRangePriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-RangePriceTokenGenerator.js';
import { __require as requireQuantityPriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-QuantityPriceTokenGenerator.js';
import { __require as requireSavingsTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-SavingsTokenGenerator.js';
import { __require as requireUnitPriceTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-pricing-UnitPriceTokenGenerator.js';
import { __require as requireVatTokenGenerator } from './vp-js-token-engine-build-tokenGenerators-VatTokenGenerator.js';
import { __require as requireIPresentation } from './vp-js-token-engine-build-tokenGenerators-IPresentation.js';
import { __require as requirePresentationTypes } from './vp-js-token-engine-build-PresentationTypes.js';
import { __require as requireZeroPrice } from './vp-js-token-engine-build-filters-zeroPrice.js';
import { __require as requireComparativePriceFilter } from './vp-js-token-engine-build-common-filters-comparativePriceFilter.js';

var hasRequiredBuild;

function requireBuild () {
	if (hasRequiredBuild) return build;
	hasRequiredBuild = 1;
	(function (exports) {

		var _interopRequireDefault = requireInteropRequireDefault();
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
		Object.defineProperty(exports, "ComparativeDisplayType", {
		  enumerable: true,
		  get: function () {
		    return _comparativePriceFilter.ComparativeDisplayType;
		  }
		});
		Object.defineProperty(exports, "ICouponCallout", {
		  enumerable: true,
		  get: function () {
		    return _CouponCalloutTokenGenerator.ICouponCallout;
		  }
		});
		Object.defineProperty(exports, "IPercentage", {
		  enumerable: true,
		  get: function () {
		    return _PercentageTokenGenerator.IPercentage;
		  }
		});
		Object.defineProperty(exports, "IPlusOrMinus", {
		  enumerable: true,
		  get: function () {
		    return _PlusOrMinusTokenGenerator.IPlusOrMinus;
		  }
		});
		Object.defineProperty(exports, "IPresentation", {
		  enumerable: true,
		  get: function () {
		    return _IPresentation.default;
		  }
		});
		Object.defineProperty(exports, "IPrice", {
		  enumerable: true,
		  get: function () {
		    return _PriceTokenGenerator.IPrice;
		  }
		});
		Object.defineProperty(exports, "IQuantityPrice", {
		  enumerable: true,
		  get: function () {
		    return _QuantityPriceTokenGenerator.IQuantityPrice;
		  }
		});
		Object.defineProperty(exports, "IRangePrice", {
		  enumerable: true,
		  get: function () {
		    return _RangePriceTokenGenerator.IRangePrice;
		  }
		});
		Object.defineProperty(exports, "ISavings", {
		  enumerable: true,
		  get: function () {
		    return _SavingsTokenGenerator.ISavings;
		  }
		});
		Object.defineProperty(exports, "IUnitPrice", {
		  enumerable: true,
		  get: function () {
		    return _UnitPriceTokenGenerator.IUnitPrice;
		  }
		});
		Object.defineProperty(exports, "IVatMessage", {
		  enumerable: true,
		  get: function () {
		    return _VatTokenGenerator.IVatMessage;
		  }
		});
		Object.defineProperty(exports, "PresentationProvider", {
		  enumerable: true,
		  get: function () {
		    return _PresentationProvider.default;
		  }
		});
		Object.defineProperty(exports, "PresentationTokenFactory", {
		  enumerable: true,
		  get: function () {
		    return _PresentationTokenFactory.default;
		  }
		});
		Object.defineProperty(exports, "PricePresentationType", {
		  enumerable: true,
		  get: function () {
		    return _PresentationTypes.default;
		  }
		});
		Object.defineProperty(exports, "TokenEngine", {
		  enumerable: true,
		  get: function () {
		    return _TokenEngine.default;
		  }
		});
		Object.defineProperty(exports, "ZeroDisplayType", {
		  enumerable: true,
		  get: function () {
		    return _zeroPrice.ZeroDisplayType;
		  }
		});
		exports.default = void 0;
		var _TokenEngine = _interopRequireDefault(requireTokenEngine());
		var _PresentationProvider = _interopRequireDefault(requirePresentationProvider());
		var _PresentationTokenFactory = _interopRequireDefault(requirePresentationTokenFactory());
		var _CouponCalloutTokenGenerator = requireCouponCalloutTokenGenerator();
		var _PercentageTokenGenerator = requirePercentageTokenGenerator();
		var _PlusOrMinusTokenGenerator = requirePlusOrMinusTokenGenerator();
		var _PriceTokenGenerator = requirePriceTokenGenerator();
		var _RangePriceTokenGenerator = requireRangePriceTokenGenerator();
		var _QuantityPriceTokenGenerator = requireQuantityPriceTokenGenerator();
		var _SavingsTokenGenerator = requireSavingsTokenGenerator();
		var _UnitPriceTokenGenerator = requireUnitPriceTokenGenerator();
		var _VatTokenGenerator = requireVatTokenGenerator();
		var _IPresentation = _interopRequireDefault(requireIPresentation());
		var _PresentationTypes = _interopRequireDefault(requirePresentationTypes());
		var _zeroPrice = requireZeroPrice();
		var _comparativePriceFilter = requireComparativePriceFilter();
		exports.default = _TokenEngine.default;
		
	} (build));
	return build;
}

export { requireBuild as __require };
//# sourceMappingURL=vp-js-token-engine-build-index.js.map
